export default __webpack_public_path__ + "static/media/shape-avatar.096ea801.svg";